
import React from 'react';
import { useClubs } from '@/hooks/useClubs';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Plus } from 'lucide-react';
import { useSeasonManagement } from '@/hooks/useSeasonManagement';
import { SeasonForm } from './SeasonForm';
import { SeasonTable } from './SeasonTable';

export const SeasonManagement = () => {
  const { clubs } = useClubs();
  const {
    seasons,
    loading,
    isDialogOpen,
    setIsDialogOpen,
    editingSeason,
    seasonYear,
    setSeasonYear,
    seasonName,
    setSeasonName,
    selectedClubId,
    setSelectedClubId,
    isSubmitting,
    handleSubmit,
    handleEdit,
    handleDelete,
    handleDialogClose,
  } = useSeasonManagement();

  if (loading) {
    return <div>Loading seasons...</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-lg font-semibold">Seasons</h3>
          <p className="text-sm text-muted-foreground">
            Manage seasons for your clubs
          </p>
        </div>
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
          <DialogTrigger asChild>
            <Button>
              <Plus className="h-4 w-4 mr-2" />
              Add Season
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>
                {editingSeason ? 'Edit Season' : 'Create New Season'}
              </DialogTitle>
              <DialogDescription>
                {editingSeason ? 'Update the season details.' : 'Enter the details for the new season.'}
              </DialogDescription>
            </DialogHeader>
            <SeasonForm
              clubs={clubs}
              editingSeason={editingSeason}
              seasonYear={seasonYear}
              setSeasonYear={setSeasonYear}
              seasonName={seasonName}
              setSeasonName={setSeasonName}
              selectedClubId={selectedClubId}
              setSelectedClubId={setSelectedClubId}
              isSubmitting={isSubmitting}
              onSubmit={handleSubmit}
              onCancel={handleDialogClose}
            />
          </DialogContent>
        </Dialog>
      </div>

      <SeasonTable
        seasons={seasons}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </div>
  );
};
